<script setup>
import {ref, computed, onBeforeMount} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useStore} from 'vuex'
import MonitoringForm from './MonitoringForm.vue'
import { can } from '@/composables/useCan'

const store = useStore()
const route = useRoute()
const router = useRouter()

const projectId = route.params.project_id
const project = computed(() => store.getters['project/current'])
const canRead = ref(false)

onBeforeMount(async () => {
  await store.dispatch('project/fetchProject', projectId)
  await store.dispatch('access/ensure', route.params.org_id).catch(() => {})
  canRead.value = can('project_settings', 'read', { projectId: Number(projectId) })

  if (!canRead.value) {
    router.push({name: 'ProjectHome', params: {project_id: projectId}})
  }
})
</script>

<template>
  <div class="max-w-[60%] space-y-3" v-if="canRead">
    <MonitoringForm v-if="project.project_id" :project="project" />
  </div>
</template>
